'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _ShareInput = require('../../decorators/ShareInput');

var _ShareInput2 = _interopRequireDefault(_ShareInput);

var _Functions = require('../../core/Functions');

var _SyntheticEvent = require('../../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _refObject = require('../../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _renderProp = require('../../utils/propTypes/renderProp');

var RenderProp = _interopRequireWildcard(_renderProp);

var _component = require('../../utils/propTypes/component');

var _component2 = _interopRequireDefault(_component);

var _OptionTypes = require('../../types/OptionTypes');

var _PlacementConstants = require('../../tooltip/PlacementConstants');

var _UIAbstractDropdownWithSearchbox = require('../../dropdown/abstract/UIAbstractDropdownWithSearchbox');

var _UIAbstractDropdownWithSearchbox2 = _interopRequireDefault(_UIAbstractDropdownWithSearchbox);

var _UITypeaheadSearch = require('../../typeahead/search/UITypeaheadSearch');

var _UITypeaheadSearch2 = _interopRequireDefault(_UITypeaheadSearch);

var _UITag = require('../../tag/UITag');

var _UITag2 = _interopRequireDefault(_UITag);

var _SelectOptionUtils = require('../utils/SelectOptionUtils');

var _pickValidProps = require('react-utils/pickValidProps');

var _pickValidProps2 = _interopRequireDefault(_pickValidProps);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DISPLAY_NONE_STYLE = { display: 'none' };

var buttonContentPropTypes = {
  buttonText: _react.PropTypes.node.isRequired
};

var noop = function noop() {};

var UISelectWithButtonAnchor = _react2.default.createClass({
  displayName: 'UISelectWithButtonAnchor',

  propTypes: {
    autoFocus: _react.PropTypes.bool,
    autoload: _react.PropTypes.bool,
    ButtonContent: RenderProp.getPropType({
      propTypes: buttonContentPropTypes
    }),
    buttonSize: _UIAbstractDropdownWithSearchbox2.default.propTypes.buttonSize,
    buttonStyle: _react.PropTypes.object,
    buttonUse: _UIAbstractDropdownWithSearchbox2.default.propTypes.buttonUse,
    cache: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.bool]),
    caretRenderer: _UIAbstractDropdownWithSearchbox2.default.propTypes.caretRenderer,
    closeOnTargetLeave: _UIAbstractDropdownWithSearchbox2.default.propTypes.closeOnTargetLeave,
    disabled: _react.PropTypes.bool,
    dropdownClassName: _react.PropTypes.string,
    dropdownContentRef: _react.PropTypes.func,
    dropdownFooter: _react.PropTypes.node,
    error: _react.PropTypes.bool,
    inputRef: _refObject2.default.isRequired,
    menuWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.oneOf(['auto'])]),
    minimumSearchCount: _react.PropTypes.number,
    multi: _react.PropTypes.bool,
    isOpen: _react.PropTypes.bool.isRequired,
    loadOptions: _react.PropTypes.func,
    onChange: _react.PropTypes.func,
    onInputValueChange: _react.PropTypes.func,
    onOpenChange: _react.PropTypes.func,
    options: _react.PropTypes.arrayOf(_OptionTypes.OptionOrGroupType),
    placeholder: _react.PropTypes.node,
    placement: _react.PropTypes.oneOf(_PlacementConstants.PLACEMENTS),
    readOnly: _react.PropTypes.bool,
    resetOption: _OptionTypes.OptionType.isRequired,
    resetValue: _OptionTypes.ValueType,
    resultsClassName: _react.PropTypes.string,
    searchable: _react.PropTypes.bool,
    searchClassName: _react.PropTypes.string,
    SearchInput: _component2.default,
    searchPlaceholder: _react.PropTypes.string,
    selectComponent: _react.PropTypes.func.isRequired,
    selectRef: _react.PropTypes.func,
    value: _react.PropTypes.any,
    valueRenderer: _react.PropTypes.func,
    _forcePlaceholder: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return _extends({}, _UIAbstractDropdownWithSearchbox2.default.defaultProps, {
      searchable: true
    });
  },
  getInitialState: function getInitialState() {
    return {
      inputCache: {},
      inputValue: '',
      searchCount: 0
    };
  },
  componentWillMount: function componentWillMount() {
    this._defaultInputRef = { current: null };
  },
  componentDidMount: function componentDidMount() {
    var _props = this.props,
        autoload = _props.autoload,
        cache = _props.cache,
        isOpen = _props.isOpen,
        loadOptions = _props.loadOptions,
        selectComponent = _props.selectComponent;

    // Mount a separate Select.Async instance to perform autoload, if needed. This is a weird hack,
    // but a necessary one since the normal Select isn't mounted until the user opens the dropdown.

    if (autoload && loadOptions && !isOpen) {
      this._autoloadSelectEl = document.createElement('div');
      var SelectComponent = selectComponent;
      _reactDom2.default.render(_react2.default.createElement(SelectComponent, {
        autoload: autoload,
        cache: typeof cache === 'undefined' ? this.state.inputCache : cache,
        loadOptions: loadOptions
      }), this._autoloadSelectEl);
    }
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var isOpen = this.props.isOpen;

    if (!isOpen && nextProps.isOpen) {
      this.setState({ hasOpened: true });
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._autoloadSelectEl) {
      _reactDom2.default.unmountComponentAtNode(this._autoloadSelectEl);
      this._autoloadSelectEl = null;
    }
  },
  focus: function focus() {
    var onOpenChange = this.props.onOpenChange;

    onOpenChange((0, _SyntheticEvent2.default)(true));
  },
  selectRefCallback: function selectRefCallback(ref) {
    var selectRef = this.props.selectRef;

    // When react-select mounts, ask it how many (flattened) options it has

    this._selectRef = ref;
    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      this.setState({ searchCount: internalSelect._flatOptions.length });
    }

    if (selectRef) {
      selectRef(ref);
    }
  },
  getInternalSelect: function getInternalSelect() {
    // Return our react-select component instance, or null
    if (!this._selectRef) {
      return null;
    }
    if (!this._selectRef.select) {
      return this._selectRef;
    }
    // _selectRef must be an <Async> or <Creatable> wrapper
    return this._selectRef.select;
  },
  getInternalAsyncSelect: function getInternalAsyncSelect() {
    // Return our react-select Async instance, or null
    if (!this._selectRef || !this._selectRef.select) {
      return null;
    }
    return this._selectRef;
  },
  handleInputKeyDown: function handleInputKeyDown(evt) {
    var _this = this;

    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      internalSelect.handleKeyDown(evt);
      setTimeout(function () {
        _this.forceUpdate(); // Ensure that the input renders with updated ARIA attrs on up/down
      });
    }
  },
  handleInputChange: function handleInputChange(evt) {
    var onInputValueChange = this.props.onInputValueChange;

    (0, _Functions.callIfPossible)(onInputValueChange, evt);
    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      internalSelect.handleInputChange(evt);
    }
    // This setState() forces an update, ensuring that Tether is repositioned properly.
    this.setState({
      inputValue: evt.target.value
    });
  },
  handleInputFocus: function handleInputFocus() {
    // React Select thinks it's closed when its input receives a blur event.
    // We don't want that, because it ignores keydown events when closed.
    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      internalSelect.setState({ isOpen: true });
    }
  },
  handleFocusLeave: function handleFocusLeave() {
    // Temporarily disabled. This causes close-and-reopen when clicking the anchor.
    // const { onOpenChange } = this.props;
    // onOpenChange(SyntheticEvent(false));
  },
  handleRemoveValueClick: function handleRemoveValueClick(optionValue, evt) {
    var _this2 = this;

    var _props2 = this.props,
        onChange = _props2.onChange,
        value = _props2.value;

    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      var internalSelectValueArray = internalSelect.getValueArray(internalSelect.props.value);
      internalSelect.setValue(internalSelectValueArray.filter(function (option) {
        return option.value !== optionValue;
      }));
    } else {
      // Select is unmounted (e.g. because the dropdown is closed), so we handle the change
      // ourselves. Note that the "value" prop on UISelectWithButtonAnchor is an array of options.
      var allOptions = (value || []).map(function (v) {
        return (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' ? v : _this2.getOptionForSingleValue(v);
      });
      var newOptions = allOptions.filter(function (v) {
        return v.value !== optionValue;
      });
      onChange(newOptions);
    }
    evt.stopPropagation(); // Prevent dropdown toggle
  },
  hasSearchbox: function hasSearchbox(_ref) {
    var loadOptions = _ref.loadOptions,
        minimumSearchCount = _ref.minimumSearchCount,
        searchable = _ref.searchable;

    // No search, no searchbox.
    if (!searchable) {
      return false;
    }
    // If we're in async mode, always show the searchbox. Otherwise, show it only if the number of
    // (flattened) options meets minimumSearchCount, or if a search has been entered.
    return !!loadOptions || this.state.searchCount >= minimumSearchCount || Boolean(this.state.inputValue);
  },
  getOptionForSingleValue: function getOptionForSingleValue(singleValue) {
    var options = this.props.options;
    // If the given "value" is actually an option, return it as-is.

    if ((typeof singleValue === 'undefined' ? 'undefined' : _typeof(singleValue)) === 'object' && singleValue.value) {
      return singleValue;
    }
    // If the given value maps to an option, return that.
    var option = (0, _SelectOptionUtils.getValueOption)(options, singleValue);
    if (option) {
      return option;
    }
    // Otherwise, return a new option with the given value.
    return { text: singleValue, value: singleValue };
  },
  getButtonContent: function getButtonContent(_ref2) {
    var disabled = _ref2.disabled,
        readOnly = _ref2.readOnly,
        loadOptions = _ref2.loadOptions,
        multi = _ref2.multi,
        options = _ref2.options,
        placeholder = _ref2.placeholder,
        resetOption = _ref2.resetOption,
        resetValue = _ref2.resetValue,
        value = _ref2.value,
        valueRenderer = _ref2.valueRenderer,
        _forcePlaceholder = _ref2._forcePlaceholder;

    if (_forcePlaceholder) {
      return {
        valueIsValid: true,
        buttonText: placeholder
      };
    }
    if (multi) {
      var renderedMultiValues = this.renderMultiValues({
        disabled: disabled,
        readOnly: readOnly,
        placeholder: placeholder,
        value: value,
        valueRenderer: valueRenderer
      });
      return {
        valueIsValid: true,
        buttonText: _react2.default.createElement(
          'span',
          {
            className: (0, _classNames2.default)('private-form__selectplus--multi-values', {
              'has-value-tags': Array.isArray(renderedMultiValues)
            })
          },
          renderedMultiValues
        )
      };
    }
    return (0, _SelectOptionUtils.getButtonProps)({
      async: !!loadOptions,
      options: options,
      placeholder: placeholder,
      resetOption: resetOption,
      resetValue: resetValue,
      value: value,
      valueRenderer: valueRenderer
    });
  },
  getEventProps: function getEventProps(props) {
    var eventPropKeyRegex = /^on[A-Z]/;
    return Object.keys(props).filter(function (key) {
      return key !== 'onClose' && key !== 'onInputChange' && key !== 'onInputKeyDown' && key !== 'onOpen' && key !== 'onInputValueChange';
    }).reduce(function (acc, key) {
      if (!key) return acc;
      if (key.match(eventPropKeyRegex)) {
        acc[key] = props[key];
      }
      return acc;
    }, {});
  },
  renderMultiValues: function renderMultiValues(_ref3) {
    var _this3 = this;

    var disabled = _ref3.disabled,
        readOnly = _ref3.readOnly,
        placeholder = _ref3.placeholder,
        value = _ref3.value,
        valueRenderer = _ref3.valueRenderer;

    if (!Array.isArray(value) || value.length === 0) {
      return placeholder;
    }
    return value.map(function (v) {
      var option = _this3.getOptionForSingleValue(v);
      var handleCloseClick = _this3.handleRemoveValueClick.bind(_this3, option.value);
      return _react2.default.createElement(
        _UITag2.default,
        {
          _bordered: true,
          closeable: !disabled && !readOnly && option.clearableValue !== false,
          key: option.value,
          onCloseClick: handleCloseClick,
          use: option.tagUse || 'default'
        },
        valueRenderer(option)
      );
    });
  },
  renderSearch: function renderSearch(_ref4, _ref5) {
    var inputRef = _ref4.inputRef,
        onPaste = _ref4.onPaste,
        searchClassName = _ref4.searchClassName,
        SearchInput = _ref4.SearchInput,
        searchPlaceholder = _ref4.searchPlaceholder;
    var hasSearchbox = _ref5.hasSearchbox;

    var ariaActiveDescendant = void 0;
    var ariaOwns = void 0;
    var internalSelect = this.getInternalSelect();
    if (internalSelect) {
      var valueArray = internalSelect.getValueArray(internalSelect.props.value);
      ariaActiveDescendant = internalSelect._instancePrefix + '-option-' + internalSelect.getFocusableOptionIndex(valueArray[0]);
      ariaOwns = internalSelect._instancePrefix + '--list';
    }

    return _react2.default.createElement(_UITypeaheadSearch2.default, {
      'aria-activedescendant': ariaActiveDescendant,
      'aria-owns': ariaOwns,
      autoFocus: this.state.hasOpened,
      className: (0, _classNames2.default)(searchClassName, { 'sr-only': !hasSearchbox }),
      Input: SearchInput,
      inputRef: inputRef,
      onKeyDown: this.handleInputKeyDown,
      onChange: this.handleInputChange,
      onFocus: this.handleInputFocus,
      onPaste: onPaste,
      placeholder: searchPlaceholder,
      role: 'combobox'
    });
  },
  render: function render() {
    var _props3 = this.props,
        autoFocus = _props3.autoFocus,
        ButtonContent = _props3.ButtonContent,
        buttonSize = _props3.buttonSize,
        buttonStyle = _props3.buttonStyle,
        buttonUse = _props3.buttonUse,
        cache = _props3.cache,
        caretRenderer = _props3.caretRenderer,
        className = _props3.className,
        closeOnTargetLeave = _props3.closeOnTargetLeave,
        disabled = _props3.disabled,
        dropdownClassName = _props3.dropdownClassName,
        dropdownContentRef = _props3.dropdownContentRef,
        dropdownFooter = _props3.dropdownFooter,
        error = _props3.error,
        id = _props3.id,
        inputRef = _props3.inputRef,
        isOpen = _props3.isOpen,
        loadOptions = _props3.loadOptions,
        menuWidth = _props3.menuWidth,
        minimumSearchCount = _props3.minimumSearchCount,
        multi = _props3.multi,
        onChange = _props3.onChange,
        onPaste = _props3.onPaste,
        options = _props3.options,
        placeholder = _props3.placeholder,
        placement = _props3.placement,
        readOnly = _props3.readOnly,
        resetValue = _props3.resetValue,
        searchClassName = _props3.searchClassName,
        searchPlaceholder = _props3.searchPlaceholder,
        resetOption = _props3.resetOption,
        resultsClassName = _props3.resultsClassName,
        searchable = _props3.searchable,
        SearchInput = _props3.SearchInput,
        selectComponent = _props3.selectComponent,
        __selectRef = _props3.selectRef,
        value = _props3.value,
        valueRenderer = _props3.valueRenderer,
        _forcePlaceholder = _props3._forcePlaceholder,
        rest = _objectWithoutProperties(_props3, ['autoFocus', 'ButtonContent', 'buttonSize', 'buttonStyle', 'buttonUse', 'cache', 'caretRenderer', 'className', 'closeOnTargetLeave', 'disabled', 'dropdownClassName', 'dropdownContentRef', 'dropdownFooter', 'error', 'id', 'inputRef', 'isOpen', 'loadOptions', 'menuWidth', 'minimumSearchCount', 'multi', 'onChange', 'onPaste', 'options', 'placeholder', 'placement', 'readOnly', 'resetValue', 'searchClassName', 'searchPlaceholder', 'resetOption', 'resultsClassName', 'searchable', 'SearchInput', 'selectComponent', 'selectRef', 'value', 'valueRenderer', '_forcePlaceholder']);

    var _getButtonContent = this.getButtonContent({
      disabled: disabled,
      readOnly: readOnly,
      loadOptions: loadOptions,
      multi: multi,
      options: options,
      placeholder: placeholder,
      resetOption: resetOption,
      resetValue: resetValue,
      value: value,
      valueRenderer: valueRenderer,
      _forcePlaceholder: _forcePlaceholder
    }),
        buttonText = _getButtonContent.buttonText,
        valueIsValid = _getButtonContent.valueIsValid;

    var hasSearchbox = this.hasSearchbox({
      loadOptions: loadOptions,
      minimumSearchCount: minimumSearchCount,
      searchable: searchable
    });
    var SelectComponent = selectComponent;

    return _react2.default.createElement(
      _UIAbstractDropdownWithSearchbox2.default,
      _extends({}, (0, _pickValidProps2.default)({}, this.props), this.getEventProps(rest), {
        _useNativeButton: false,
        'aria-invalid': error != null ? error : !valueIsValid,
        autoFocus: autoFocus,
        buttonText: ButtonContent == null ? buttonText : _react2.default.createElement(ButtonContent, { buttonText: buttonText }),
        buttonSize: buttonSize,
        buttonUse: buttonUse,
        caretRenderer: caretRenderer,
        className: className,
        closeOnTargetLeave: closeOnTargetLeave,
        disabled: disabled,
        dropdownClassName: dropdownClassName,
        dropdownContentRef: dropdownContentRef,
        hasSearchbox: hasSearchbox,
        id: id,
        menuWidth: menuWidth,
        multiline: multi,
        onFocusLeave: this.handleFocusLeave,
        onOpenComplete: this.handleOpenComplete,
        open: isOpen,
        placement: placement,
        readOnly: readOnly,
        style: buttonStyle
      }),
      this.renderSearch({
        inputRef: inputRef,
        onPaste: onPaste,
        searchClassName: searchClassName,
        SearchInput: SearchInput,
        searchPlaceholder: searchPlaceholder
      }, { hasSearchbox: hasSearchbox }),
      _react2.default.createElement(
        'span',
        {
          className: (0, _classNames2.default)('private-typeahead-results', resultsClassName),
          'data-dropdown-results': true
        },
        _react2.default.createElement(SelectComponent, _extends({}, rest, {
          autosize: false,
          cache: typeof cache === 'undefined' ? this.state.inputCache : cache,
          disabled: disabled,
          isOpen: true,
          loadOptions: loadOptions,
          multi: multi,
          onChange: onChange,
          options: options,
          readOnly: readOnly,
          ref: this.selectRefCallback,
          resetValue: resetValue,
          scrollMenuIntoView: false,
          style: DISPLAY_NONE_STYLE,
          tabIndex: '-1',
          value: value,
          valueRenderer: noop
        }))
      ),
      dropdownFooter
    );
  }
});

exports.default = (0, _ShareInput2.default)(UISelectWithButtonAnchor);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/input/internal/UISelectWithButtonAnchor.js
// module id = 558
// module chunks = 3 4 5